import { Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { User } from 'shared';
import { LayoutService } from '../home/layout.service';
import { TrackerService } from '../stores/tracker.service';
import { UserDomain } from '../user-domains/user-domain';
import { UserDomainService } from '../user-domains/user-domain.service';

@Component({
  selector: 'app-trackers-grid',
  templateUrl: './trackers-grid.component.html',
  styleUrls: ['./trackers-grid.component.scss']
})

export class TrackersGridComponent {
  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  canAssign: boolean;
  domains: UserDomain[];
  selectedDomain?: UserDomain;
  hasSingleDomain: boolean;
  phonePattern: any = /^\+\s*212\s*\d\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{2}$/;
  imeiPattern: any = /^\s*\d{15}$/;
  isPump: boolean;
  fuelConsumption: string = '';
  fuelHrConsumptionRate: string = '';
  selectedBrand: string = '';
  selectedModel: string = '';
  modelsSrc: string[] = [];

  feulDataSource: string = "flowmeter";

  feulDataSources = [
    { text: "Flowmeter", value: "flowmeter" },
    { text: "CanBus", value: "canbus" },
  ];

  brandSrc = ["BCE", "Teltonika"];

  models: { [key: string]: string[] } = {
    'BCE': ['FMS500 Light+', 'FMS500 StCAN'],
    'Teltonika': ['FMB125/FMC125', 'FMC150']
  };

  canBusSensors = [
    { text: "AccelerationPedalPosition", value: "AccelerationPedalPosition" },
    { text: "FuelLevel", value: "FuelLevel" },
    { text: "TotalEngineHours", value: "TotalEngineHours" },
    { text: "TotalFuelUsed", value: "TotalFuelUsed" },
    { text: "TotalVehicleDistance", value: "TotalVehicleDistance" },
    { text: "EngineSpeed", value: "EngineSpeed" },
    { text: "EngineCoolantTemperature", value: "EngineCoolantTemperature" },
    { text: "FuelLevel2", value: "FuelLevel2" },
    { text: "EngineLoad", value: "EngineLoad" },
    { text: "ServiceDistance1", value: "ServiceDistance1" },
    { text: "AmbientAirTemperature", value: "AmbientAirTemperature" },
    { text: "FuelRate", value: "FuelRate" }
  ];

  constructor(
    private trackerService: TrackerService,
    private userDomainsService: UserDomainService,
    private layoutService: LayoutService,
    public user: User
  ) {
    // Data source
    this.ds = trackerService.newDataSource();

    // Permissions
    this.canEdit = user.can('edit trackers');
    this.canAdd = user.can('add trackers');
    this.canDelete = user.can('delete trackers');
    this.canAssign = user.can('assign trackers');

    // User domains
    this.domains = userDomainsService.domains;
    this.selectedDomain = userDomainsService.selectedDomain();
    this.hasSingleDomain = userDomainsService.hasSingleDomain();

    // Bindings
    this.imeiValidation = this.imeiValidation.bind(this);
    this.navigateToTrackerAssignment = this.navigateToTrackerAssignment.bind(this);
    this.updateCellValue = this.updateCellValue.bind(this);
  }

  displayCheckAvailable(cellInfo: any): string {
    return !!cellInfo.valueText ? cellInfo.valueText : 'Indisponbile';
  }

  imeiValidation(params: any) {
    return this.trackerService.checkIMEI(params.value, params.data?.id).toPromise();
  }

  navigateToTrackerAssignment(e: any) {
    this.layoutService.openTab({
      id: 'trackers-assignment-grid-' + e.row.data.imei,
      type: 'component',
      title: 'Transferts ' + e.row.data.imei,
      componentName: 'trackers-assignment-grid',
      componentState: {
        tracker: e.row.data,
      }
    });
  }

  onInitNewRow(e: any) {
    this.isPump = false;
    this.feulDataSource = "flowmeter";
    this.fuelHrConsumptionRate = "";
    this.fuelConsumption = "";
    this.selectedModel = "";
    this.selectedBrand = "";
    this.modelsSrc = [];
  }

  onEditingStart(e: any) {
    this.isPump = e.data.is_pump;
    this.feulDataSource = e.data.settings.feul_data_source;
    this.fuelHrConsumptionRate = e.data.settings.fuel_hr_consumption_rate.sensor;
    this.fuelConsumption = e.data.settings.fuel_consumption.sensor;
    this.selectedBrand = e.data.brand;
    this.modelsSrc = this.models[e.data.brand] || [];
    this.selectedModel = e.data.model;
  }

  onBrandChanged(event: any, cellInfo: any) {
    cellInfo.setValue(event.value);
    this.selectedBrand = event.value;
    this.modelsSrc = this.models[event.value] || [];
  }

  updateCellValue(e: any, cellInfo: any, property: string) {
    if (Object.prototype.hasOwnProperty.call(this, property)) {
      cellInfo.setValue(e.value);
      this[property] = e.value;
    } else {
      console.warn(`Property '${property}' does not exist on the object.`);
    }
  }
}
